export class SelectWeeks {
  constructor(public id: number,  public name: string) { }
}
